import WMContainer from './WMContainer'
export default WMContainer
